module.exports = __webpack_public_path__ + "img/W7022-thumb.07da3853.jpg";